import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface exportDeviceDataGraphDataState {
  isLoading: boolean
  loadingError: string | null
  exportDeviceDataGraph: any
}

// Initial state of the slice
const initialState: exportDeviceDataGraphDataState = {
  isLoading: true,
  loadingError: null,
  exportDeviceDataGraph: null
}

// Slice to return from action
export const exportDeviceGraphKPIDataSlice = createSlice({
  name: 'exportDeviceKPIDataGraph',
  initialState,
  reducers: {
    exportDeviceKPIDataGraphLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: null,
        exportDeviceDataGraph: []
      }
    },
    exportDeviceKPIDataGraphUpdateAction: (state, action: PayloadAction< any >) => {
      return {
        isLoading: false,
        loadingError: null,
        exportDeviceDataGraph: action.payload
      }
    },
    exportDeviceKPIDataGraphErrorAction: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        exportDeviceDataGraph: null
      }
    }
  }
})

// Actions to export
export const {
  exportDeviceKPIDataGraphLoadingAction,
  exportDeviceKPIDataGraphUpdateAction,
  exportDeviceKPIDataGraphErrorAction
} = exportDeviceGraphKPIDataSlice.actions

export default exportDeviceGraphKPIDataSlice.reducer
